// extracted by mini-css-extract-plugin
export default {"logo":"navbar_logo__pUXqg","navList":"navbar_navList__0fVUf"};